// @ts-check

import React from 'react';
import { func, object, string } from 'prop-types';
import USER from '../ts/profileEditorEnum';
import ProfilePaper from './ProfilePaper';
import Grid from '@mui/material/Grid';
import ProfileEditorField from './ProfileEditorField';
import ProfileBadge from './ProfileBadge';

/**
 * @component ProfileEditorSummary
 * @param {Object} props
 * @param {EditorUserType} props.editorUser
 * @param {EditorUserValidType} props.valid
 * @param {(name: string, payload: any)=>void} props.onHandle
 * @returns {JSX.Element}
 */
function ProfileEditorSummary({ editorUser, valid, onHandle }) {
	return (
		<ProfilePaper>
			<Grid container spacing={2} justifyContent="space-between" alignItems="center">
				<Grid item lg={3.375 / 2} xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
					<ProfileBadge userImg={editorUser[USER.IMAGE]} onHandle={onHandle} />
				</Grid>
				<Grid item lg={3.375} xs={12}>
					<ProfileEditorField
						name={USER.FIRST_NAME}
						required={true}
						label="First name"
						value={editorUser[USER.FIRST_NAME]}
						valid={valid[USER.FIRST_NAME]}
						onHandleUser={onHandle}
					/>
				</Grid>
				<Grid item lg={3.375} xs={12}>
					<ProfileEditorField
						name={USER.LAST_NAME}
						required={true}
						label="Last name"
						value={editorUser[USER.LAST_NAME]}
						valid={valid[USER.LAST_NAME]}
						onHandleUser={onHandle}
					/>
				</Grid>
				<Grid item lg={3.375} xs={12}>
					<ProfileEditorField
						name={USER.USERNAME}
						required={true}
						label="Username"
						value={editorUser[USER.USERNAME]}
						valid={valid[USER.USERNAME]}
						onHandleUser={onHandle}
					/>
				</Grid>
			</Grid>
		</ProfilePaper>
	);
}

ProfileEditorSummary.propTypes = {
	editorUser: object,
	valid: object,
	onHandle: func,
};

export default ProfileEditorSummary;
